export default __webpack_public_path__ + "static/media/bg.11a2c685.png";